<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M76.4373 40.7179L38.2836 79.0048L15 55.64L53.1538 17.353L71.1545 22.6543L76.4373 40.7179Z" stroke="black" stroke-width="4"/>
<circle r="3.88064" transform="matrix(0.705874 0.708338 -0.705874 0.708338 61.3782 32.4647)" stroke="black" stroke-width="4"/>
<path d="M47.0748 37.8844L45.962 47.9347M45.962 47.9347L55.9774 46.818M45.962 47.9347L34.4058 59.5312M40.4835 42.4371L51.4405 53.4323M34.9194 48.0206L45.8764 59.0158" stroke="black" stroke-width="4"/>
<path d="M75.2634 52.8911L38.2836 90L21.8481 73.5072" stroke="black" stroke-width="4"/>
<path d="M62 33C100.98 28.7454 86 1 67.0843 14.3864" stroke="black" stroke-width="4"/>
</svg>

</template>
